import React from "react";

// Minimal markdown renderer for AI reports (headings, bold, lists).
export const MarkdownLite = ({ text, className = "" }) => {
  if (!text) return null;
  const lines = text.split("\n");
  const renderInline = (s) => {
    const parts = s.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((p, i) =>
      p.startsWith("**") && p.endsWith("**") ? (
        <strong key={i} className="text-white font-semibold">{p.slice(2, -2)}</strong>
      ) : (
        <span key={i}>{p}</span>
      )
    );
  };
  return (
    <div className={`space-y-2 text-sm text-zinc-400 leading-relaxed ${className}`}>
      {lines.map((line, idx) => {
        const t = line.trim();
        if (!t) return <div key={idx} className="h-1" />;
        if (t.startsWith("### ")) return <h4 key={idx} className="font-display uppercase tracking-wide text-aurora-cyan text-sm mt-3">{renderInline(t.slice(4))}</h4>;
        if (t.startsWith("## ")) return <h3 key={idx} className="font-display uppercase tracking-wide text-white text-base mt-3">{renderInline(t.slice(3))}</h3>;
        if (t.startsWith("# ")) return <h2 key={idx} className="font-display uppercase tracking-wide text-white text-lg mt-3">{renderInline(t.slice(2))}</h2>;
        if (/^[-*]\s/.test(t)) return <div key={idx} className="flex gap-2 pl-1"><span className="text-aurora-cyan">›</span><span>{renderInline(t.replace(/^[-*]\s/, ""))}</span></div>;
        if (/^\d+\.\s/.test(t)) return <div key={idx} className="flex gap-2"><span className="text-aurora-cyan font-mono">{t.match(/^\d+/)[0]}.</span><span>{renderInline(t.replace(/^\d+\.\s/, ""))}</span></div>;
        return <p key={idx}>{renderInline(t)}</p>;
      })}
    </div>
  );
};
